/**
 * Print a DOM node in an isolated iframe so SPA chrome (sidebar, POS
 * overflow/flex, fixed overlays) cannot blank or clip the print output.
 */
export function printHtmlElement(element, { title = 'Print', extraCss = '', pageWidth = '148mm', pageHeight = '210mm' } = {}) {
  if (!element) return;

  const iframe = document.createElement('iframe');
  iframe.setAttribute('title', title);
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.cssText = `position:fixed;left:-10000px;top:0;width:${pageWidth};height:${pageHeight};border:0;`;
  document.body.appendChild(iframe);

  const doc = iframe.contentDocument;
  if (!doc) {
    iframe.remove();
    window.print();
    return;
  }

  doc.open();
  doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>');
  doc.close();
  doc.title = title;

  const pending = [];
  Array.from(document.querySelectorAll('link[rel="stylesheet"], style')).forEach((node) => {
    const clone = node.cloneNode(true);
    if (clone.tagName === 'LINK') {
      pending.push(new Promise((resolve) => {
        clone.onload = resolve;
        clone.onerror = resolve;
      }));
    }
    doc.head.appendChild(clone);
  });

  const extra = doc.createElement('style');
  extra.textContent = `
@page { size: A5 portrait; margin: 8mm; }
@media print {
  @page { size: A5 portrait; margin: 8mm; }
  html, body {
    width: 100% !important;
    max-width: none !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
  }
}
${extraCss}
`;
  doc.head.appendChild(extra);

  doc.body.appendChild(element.cloneNode(true));
  doc.body.style.margin = '0';
  doc.body.style.background = '#fff';

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    iframe.remove();
  };

  const doPrint = () => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (err) {
      console.error(err);
      window.print();
    }
    if (iframe.contentWindow) {
      iframe.contentWindow.onafterprint = cleanup;
    }
    setTimeout(cleanup, 60000);
  };

  const ready = pending.length ? Promise.all(pending) : Promise.resolve();
  ready.then(() => {
    requestAnimationFrame(() => setTimeout(doPrint, 200));
  });
}
